import { render, staticRenderFns } from "./DashboardTableArchive.vue?vue&type=template&id=750a5b26&"
import script from "./DashboardTableArchive.vue?vue&type=script&lang=js&"
export * from "./DashboardTableArchive.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTableArchive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports